import { render, staticRenderFns } from "./SearchPlaces.vue?vue&type=template&id=01b65bf4&"
import script from "./SearchPlaces.vue?vue&type=script&lang=js&"
export * from "./SearchPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports